import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}


export const getCompanySettings = async (token: string, permission: string | null,) => {
  const response = await axios.get(`${API_URL}/presenze/company/settings/`, {
    headers: {
      'Authorization': `${token}`,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};

export const getCompanySettingsWithPermission = async (token: string, permission: string | null) => {
  const config: any = {
    headers: {
      'Authorization': token,
    },
  };

  if (permission) 
    config.params.permission = permission

    const response = await axios.get(`${API_URL}/presenze/company/settings/`, config);
  return response.data;
};

export const updateCompanySettings = async (token: string, settings: Record<string, any>) => {
    const response = await axios.patch(`${API_URL}/presenze/company/settings/`, settings, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    return response.data;
};

export const createGeolocationLimit = async (token: string, data: any) => {
  const response = await axios.post(`${API_URL}/presenze/company/presence/locations/`, data, {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

export const getGeolocationLimitList = async (token: string) => {
  const response = await axios.get(`${API_URL}/presenze/company/presence/locations/`,
  {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};

export const deleteGeolocationLimit = async (token: string, id: number) => {
  const response = await axios.delete(`${API_URL}/presenze/company/presence/locations/${id}/`,
   {
      headers: {
        'Authorization': `${token}`,
      },
    });
  return response.data;
};
